import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import VerifyCheckStart from "./VerifyCheckStart";
import VerifyCheckUnderwriting from "./VerifyCheckUnderwriting";
import VerifyCheckAdoptStart from "./VerifyCheckAdoptStart";
import VerifyCheckAdoptSuccess from "./VerifyCheckAdoptSuccess";
import VerifyCheckVerificationSuccess from "./VerifyCheckVerificationSuccess";
import VerifyCheckVerificationFail from "./VerifyCheckVerificationFail";
import VerifyCheckVerificationAdopted from "./VerifyCheckVerificationAdopted";
import PdfViewer from "./PdfViewer";
const VerifyCheckMaster = () => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    return React.createElement("div", null,
        verifyCheckState.processState === "start" ? React.createElement(VerifyCheckStart, null) : "",
        verifyCheckState.processState === "underwriting" ? React.createElement(VerifyCheckUnderwriting, null) : "",
        verifyCheckState.processState === "verificationSuccess" ? React.createElement(VerifyCheckVerificationSuccess, null) : "",
        verifyCheckState.processState === "verificationFail" ? React.createElement(VerifyCheckVerificationFail, null) : "",
        verifyCheckState.processState === "verificationAdopted" ? React.createElement(VerifyCheckVerificationAdopted, null) : "",
        verifyCheckState.processState === "adoptStart" ? React.createElement(VerifyCheckAdoptStart, null) : "",
        verifyCheckState.processState === "adoptSuccess" ? React.createElement(VerifyCheckAdoptSuccess, null) : "",
        verifyCheckState.processState === "showAuthorizationCert" ? React.createElement(PdfViewer, null) : "");
};
export default connect()(VerifyCheckMaster);
//# sourceMappingURL=VerifyCheckMaster.js.map